import { axiosInstance } from "../../utils/axios";
import { RootState, store } from "../../redux/store/store";
import { selectExternalConfigs } from "../../redux/feature/settings/configurations-slice";

export async function getExternalConfigs(): Promise<any> {
  try {
    const resp = await axiosInstance.get("/externalConfigs");
    return resp.data;
  } catch (error) {
    console.error("Error fetching external configs", error);
    throw error;
  }
}

export function isFeatureEnabled(featureName: string): boolean {
  const state: RootState = store.getState();
  let externalConfigs = selectExternalConfigs(state);
  return !!externalConfigs?.featureFlags?.[featureName];
}

export function isAskAiFeatureEnabled(): boolean {
  return isFeatureEnabled("askAi");
}

export function isWordWebEnabled(): boolean {
  return isFeatureEnabled("wordWeb");
}

export function isOnWordWeb(): boolean {
  return Office.context.requirements.isSetSupported("WordApiOnline", "1.1");
}

/**
 * Indicates whether the features are enabled for the current client
 *
 * - **Desktop:** always true, features always enabled.
 * - **Word Web:** true only if feature flag `wordWeb` is active
 *
 */
export function isFeatureActiveOnCurrentClient(): boolean {
  const isOnWordWeb = Office.context.requirements.isSetSupported("WordApiOnline", "1.1");
  if (!isOnWordWeb) return true;
  return isWordWebEnabled();
}
